import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import './number-card-info-body.scss';
import ShipmentApproveMode from '../shipment-mode-value/shipment-approve-mode';

const NumberCardInfoBody = forwardRef(
  (
    {
      left,
      top,
      active,
      mouseEnter,
      mouseLeave,
      direction,
      title,
      mode,
      value,
      modes,
      multiple,
    },
    ref // Forwarded ref
  ) => {
    return ReactDOM.createPortal(
      <div
        className={`number-card-info-body ${active ? 'show' : ''} ${
          direction === 'right' ? 'right' : ''
        }`}
        ref={ref} // Forwarded ref applied here
        style={{ left, top }}
        onMouseLeave={mouseLeave}
        onMouseEnter={mouseEnter}
      >
        <h3 className="title">{title}</h3>
        <div className="d-flex justify-between">
          {multiple ? (
            Object.entries(modes).map(([_, v]) => {
              return (
                <ShipmentApproveMode
                  mode={v.modeValue}
                  value={value[v.keyName]}
                />
              );
            })
          ) : (
            <>
              <ShipmentApproveMode mode={mode} value={value} />
              <ShipmentApproveMode mode={mode} value={value} />
            </>
          )}
        </div>
      </div>,
      document.body
    );
  }
);

NumberCardInfoBody.propTypes = {
  left: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  top: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  active: PropTypes.bool,
  mouseEnter: PropTypes.func,
  mouseLeave: PropTypes.func,
  direction: PropTypes.string,
  title: PropTypes.string,
  mode: PropTypes.string,
  value: PropTypes.number,
  modes: PropTypes.instanceOf(Object),
  multiple: PropTypes.bool,
};

NumberCardInfoBody.defaultProps = {
  left: 0,
  top: 0,
  active: false,
  mouseEnter: () => {},
  mouseLeave: () => {},
  direction: '',
  title: '',
  mode: '',
  value: 0,
  modes: {},
  multiple: false,
};

export default NumberCardInfoBody;
